import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { gsap } from 'gsap/all';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import App from './App.vue'

gsap.registerPlugin( ScrollToPlugin );
Vue.use(VueAxios, axios);
Vue.use(VueFlatPickr);
Vue.filter('toFixed', function (value, size) {
  if (isNaN(value)) return '';
  return parseFloat(value).toFixed(size);
});
Vue.filter('replace', function (value, toFind, toReplace) {
  return value.replace(toFind, toReplace);
});

axios.defaults.headers.common['SD-Locale'] = window.Translator.locale;
new Vue({
  render: h => h(App)
}).$mount('#app-vue')
